<div class="monitor-dashboard-kpi-grid">
  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.requestsWithinSla')}}</b>
      <div class="mt-2" v-if="!isLoading">
        <b class="color-Main fs-20">{{ displayCount(kpis.withinSlaCount) }}</b>
        <span class="ml-2 color-Main fs-20">| {{ formatPercent(kpis.withinSlaPercent) }}</span>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <span class="sr-only">{{ $t('monitorDashboard.loading') }}</span>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi" aria-hidden="true"></div>
      </div>
      <p class="fs-11 mb-0 text-muted">{{$t('monitorDashboard.processingWithin2BusinessDays')}}</p>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.requestsExceededSla')}}</b>
      <div class="mt-2" v-if="!isLoading">
        <b class="color-Main fs-20">{{ displayCount(kpis.exceededSlaCount) }}</b>
        <span class="ml-2 color-Main fs-20">| {{ formatPercent(kpis.exceededSlaPercent) }}</span>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi" aria-hidden="true"></div>
      </div>
      <p class="fs-11 mb-0 text-muted">{{$t('monitorDashboard.processedIn3OrMoreBusinessDays')}}</p>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.approvalProcessingAverage')}}</b>
      <div class="mt-2 mb-3" v-if="!isLoading">
        <b class="color-Main fs-20">{{ formatDays(kpis.approvalAvgBusinessDays) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi" aria-hidden="true"></div>
      </div>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.paymentProcessingAverage')}}</b>
      <div class="mt-2 mb-3" v-if="!isLoading">
        <b class="color-Main fs-20">{{ formatDays(kpis.paymentAvgBusinessDays) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi" aria-hidden="true"></div>
      </div>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.activationProcessingAverage')}}</b>
      <div class="mt-2 mb-3" v-if="!isLoading">
        <b class="color-Main fs-20">{{ formatDays(kpis.activationAvgBusinessDays) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi" aria-hidden="true"></div>
      </div>
      <p class="fs-11 mb-0 text-muted"></p>
    </div>
  </div>
</div>
